export var HANDLE;
(function (HANDLE) {
    // 0 is not used on purpose
    // it would evaluate as false in some parts of code
    HANDLE[HANDLE["ROTATE"] = 1] = "ROTATE";
    HANDLE[HANDLE["TOP_LEFT"] = 2] = "TOP_LEFT";
    HANDLE[HANDLE["TOP_MIDDLE"] = 3] = "TOP_MIDDLE";
    HANDLE[HANDLE["TOP_RIGHT"] = 4] = "TOP_RIGHT";
    HANDLE[HANDLE["LEFT_MIDDLE"] = 5] = "LEFT_MIDDLE";
    HANDLE[HANDLE["RIGHT_MIDDLE"] = 6] = "RIGHT_MIDDLE";
    HANDLE[HANDLE["BOTTOM_LEFT"] = 7] = "BOTTOM_LEFT";
    HANDLE[HANDLE["BOTTOM_MIDDLE"] = 8] = "BOTTOM_MIDDLE";
    HANDLE[HANDLE["BOTTOM_RIGHT"] = 9] = "BOTTOM_RIGHT";
})(HANDLE || (HANDLE = {}));
export var SeatingSequence;
(function (SeatingSequence) {
    SeatingSequence["NUMERIC"] = "123";
    SeatingSequence["ALPHABETIC"] = "abc";
})(SeatingSequence || (SeatingSequence = {}));
export var LabelsPosition;
(function (LabelsPosition) {
    LabelsPosition["LEFT"] = "left";
    LabelsPosition["RIGHT"] = "right";
    LabelsPosition["BOTH"] = "both";
})(LabelsPosition || (LabelsPosition = {}));
export var TableSeatsSides;
(function (TableSeatsSides) {
    TableSeatsSides[TableSeatsSides["TOP"] = 0] = "TOP";
    TableSeatsSides[TableSeatsSides["RIGHT"] = 1] = "RIGHT";
    TableSeatsSides[TableSeatsSides["BOTTOM"] = 2] = "BOTTOM";
    TableSeatsSides[TableSeatsSides["LEFT"] = 3] = "LEFT";
})(TableSeatsSides || (TableSeatsSides = {}));
export var Shapes;
(function (Shapes) {
    Shapes["MULTI_ROW"] = "multiRow";
    Shapes["ROW"] = "row";
    Shapes["TABLE"] = "table";
    Shapes["ROUND_TABLE"] = "roundTable";
    Shapes["AREA"] = "area";
    Shapes["TEXT"] = "text";
    Shapes["RECTANGLE"] = "rectangle";
    Shapes["CIRCLE"] = "circle";
    Shapes["LINE"] = "line";
    Shapes["ICON"] = "icon";
})(Shapes || (Shapes = {}));
export var IconType;
(function (IconType) {
    IconType["enter"] = "enter";
    IconType["exit"] = "exit";
    IconType["drinks"] = "drinks";
    IconType["wc"] = "wc";
    IconType["wcMen"] = "wcMen";
    IconType["wcWomen"] = "wcWomen";
    IconType["food"] = "food";
    IconType["stairs"] = "stairs";
    IconType["elevator"] = "elevator";
    IconType["smoking"] = "smoking";
})(IconType || (IconType = {}));
export var IconPosition;
(function (IconPosition) {
    IconPosition["top"] = "top";
    IconPosition["bottom"] = "bottom";
})(IconPosition || (IconPosition = {}));
//# sourceMappingURL=interfaces.js.map